import { createColumnHelper } from '@tanstack/react-table';
import { DebugToggle, ToggleType } from '../internal.models';
import DebugToggleAction from './debug-toggle-action';
import PocToggle from 'features/poc/poc-toggle/pocToggle';

const columnHelper = createColumnHelper<DebugToggle>();

export const getDebugToggleColumnDefs = () => {
  const columnDefs = [
    columnHelper.accessor((row) => row.name, {
      id: 'Name',
      header: () => 'Toggle Name',
      enableColumnFilter: false,
      cell: (info) => (
        <div className="text-sm truncate" title={info.getValue()}>
          {info.getValue()}
        </div>
      ),
      size: 150
    }),
    columnHelper.accessor((row) => row.enabled, {
      id: 'Enabled',
      header: () => 'Enabled',
      enableColumnFilter: false,
      cell: (info) => {
        if (info.row.original.type === ToggleType.POCToggle) {
          return <PocToggle />;
        } else {
          return <DebugToggleAction debugToggle={info.row.original} />;
        }
      },
      size: 20
    })
  ];

  return columnDefs;
};
